import { useTranslation } from 'react-i18next';
import TitMod from '../common/TitMod';
import ProdCards from '../common/ProdCards';
import useFetch from '@/api/useFetch';

function Index() {
  const { t } = useTranslation();
  const { response } = useFetch('getGames');

  return (
    <TitMod title={t('hotGames')}>
      <ProdCards list={response || []} ShowLinkOnly={true}/>
    </TitMod>
  );
}

export default Index;
